import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import axios from "axios";
import { Container } from "reactstrap";
import { Descriptions } from "antd";

const SingleMovieComponent = () => {
  let { id } = useParams();
  const [data, setData] = useState(null);

  useEffect(() => {
    if (data === null) {
      axios
        .get(`https://backendexample.sanbersy.com/api/data-movie/${id}`)
        .then((res) => {
          setData(res.data);
        });
    }
  }, [data, setData, id]);

  return (
    <Container>
      <Descriptions title="Movies Info">
        <Descriptions.Item label="Title">
          {data !== null && data.title}
        </Descriptions.Item>
        <Descriptions.Item label="Description">
          {data !== null && data.description}
        </Descriptions.Item>
        <Descriptions.Item label="Year">
          {data !== null && data.year}
        </Descriptions.Item>
        <Descriptions.Item label="Duration">
          {data !== null && data.duration} Minute
        </Descriptions.Item>
        <Descriptions.Item label="Genre">
          {data !== null && data.genre}
        </Descriptions.Item>
        <Descriptions.Item label="Rating">
          {data !== null && data.rating}
        </Descriptions.Item>
        <Descriptions.Item label="Review">
          {data !== null && data.review}
        </Descriptions.Item>
      </Descriptions>
    </Container>
  );
};

export default SingleMovieComponent;
